var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from '@angular/core';
import { BaseModalComponent } from "./base_modal.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
var PromptComponent = /** @class */ (function (_super) {
    __extends(PromptComponent, _super);
    function PromptComponent(activeModal) {
        var _this = _super.call(this, activeModal) || this;
        _this.activeModal = activeModal;
        _this.message = '';
        _this.errors = [];
        _this.onChange = new EventEmitter();
        return _this;
    }
    PromptComponent.prototype.ok = function () {
        this.activeModal.close(this.message);
    };
    return PromptComponent;
}(BaseModalComponent));
export { PromptComponent };
